import qs from "qs";
import pick from "lodash/pick";

export const filterBundles = (
  bundles = [],
  cartProducts = [],
  limit = true
) => {
  let filtered = [];

  for (let bundle of bundles) {
    if (limit && filtered.length > 0) {
      break;
    }

    // if the first matching bundle is an upsell one, then check the upsell product against the items in the cart
    const upsellItemIsInCart =
      bundle.main.documentType === "upsell_product_bundle" &&
      !!cartProducts.find(
        (cartProduct) => cartProduct.id === bundle.upsellProduct.main.productId
      );

    for (let cartProduct of cartProducts) {
      if (limit && filtered.length > 0) {
        break;
      }

      if (
        bundle.main.documentType === "upsell_product_bundle" &&
        bundle.products.find(
          (product) => product.main.productId === cartProduct.id
        )
      ) {
        const products = upsellItemIsInCart
          ? []
          : [{ ...bundle.upsellProduct, linkToProduct: true }];
        filtered.push({ ...bundle, products });
      }

      // and if the cart item matches a bundle product, and the bundle is regular type
      // push into filtered the products in the bundle
      if (
        bundle.main.documentType === "product_bundle" &&
        bundle.products.find(
          (product) => product.main.productId === cartProduct.id
        )
      ) {
        filtered.push({
          ...bundle,
          customisations: cartProduct.customisations,
        });
      }
    }
  }

  if (!limit) {
    // uniques the bundles array if there are two or more books in the same bundle
    // found in cart and returns the highest priority bundle
    filtered = filtered.filter(
      (v, i, a) => a.findIndex((t) => t.documentName === v.documentName) === i
    );
  }

  return filtered;
};

export const filterProds = (products = [], cartProducts = []) => {
  const prodIds = cartProducts.map((cp) => cp.id);
  return products.filter((product) => {
    return prodIds.indexOf(product.main.productId) === -1;
  });
};

export const buildCtaUrl = (slug, customisations, linkToProductPageOnly) => {
  let params = ["name", "surname", "gender", "phototype", "locale"];

  const search = qs.stringify(pick(customisations, params), {
    addQueryPrefix: true,
  });

  return linkToProductPageOnly
    ? `/personalized-products/${slug}${search}`
    : `/personalized-products/${slug}/preview${search}`;
};
